import './Table.css'
import style from './Table.module.css'
import { TableItem } from '../../UI/TableItem/TableItem'
import { useSelector } from 'react-redux'
import { getCablesTableThunk } from '../../Redux/Slices/Cables/thunks'
import { useEffect, useMemo, useState } from 'react'
import Preloader from '../../UI/Preloader/Preloader'
import { useDispatch } from 'react-redux'
import { TableFilterSelect } from '../../Components/Select/TableFilterSelect'
import { setTableMarketplaceTags, setTableVendorsTags, setTableAliasTags } from '../../Redux/Slices/Cables'
import {ReactComponent as Reset} from '../../Assets/icons/resetCurrentColor.svg'
import {ReactComponent as Market} from '../../Assets/icons/market.svg'
import {ReactComponent as Cable} from '../../Assets/icons/cable.svg'
import {ReactComponent as Vendor} from '../../Assets/icons/vendor.svg'

export function Table () {
    const markets = useSelector((state) => state.cables.cablesTable)
    const TableSelectMarketplaceIsOpen = useSelector(state => state.select.TableSelectMarketplace)
    const TableSelectAliasIsOpen = useSelector(state => state.select.TableSelectAlias)
    const TableSelectVendorIsOpen = useSelector(state => state.select.TableSelectVendor)
    const TableMarketplaceTags = useSelector((state) => state.cables.tableMarketplaceTags)
    const TableAliasTags = useSelector((state) => state.cables.tableAliasTags)
    const TableVendorTags = useSelector((state) => state.cables.tableVendorsTags)
    const TableMarketPlaceActiveTags = useSelector((state) => state.cables.tableMarketActiveTags)
    const TableVendorActiveTags = useSelector((state) => state.cables.tableVendorActiveTags)
    const TableAliasActiveTags = useSelector((state) => state.cables.tableAliasActiveTags)
    const [filterMarkets, setFilterMarkets] = useState(markets)
    const allFilters = useMemo(() => [...TableMarketPlaceActiveTags, ...TableAliasActiveTags, ...TableVendorActiveTags], [TableMarketPlaceActiveTags, TableAliasActiveTags, TableVendorActiveTags])
    
    useEffect(() => {
        if(markets.length === 0) return 
        setFilterMarkets(markets)
    }, [markets])    

    useEffect(() => {       
        setFilterMarkets(markets
            .filter(item => TableMarketPlaceActiveTags.length > 0 ? TableMarketPlaceActiveTags.some(elem => elem.marketplace_id === item.marketplace_id) : true)
            .map(item => TableAliasActiveTags.length > 0 ? {...item, aliases: item.aliases.filter(elem1 =>  TableAliasActiveTags.some(elem2 => elem2.alias_id === elem1.alias_id))} : item)
            .map(item => TableVendorActiveTags.length > 0 
                ? {...item, aliases : item.aliases.map(elem => ({...elem, prices: elem.prices.filter(elem1 => TableVendorActiveTags.some(elem2 => elem2.vendor_id === elem1.vendor_id))}))} 
                : item)
        )
    }, [TableMarketPlaceActiveTags, TableAliasActiveTags, TableVendorActiveTags])

    
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        dispatch(getCablesTableThunk())
        .finally(() => setLoading(false))
    }, [dispatch])

    function handleDefault(){
        dispatch(setTableMarketplaceTags([]))
        dispatch(setTableAliasTags([]))
        dispatch(setTableVendorsTags([]))
    }

    if(loading) return <Preloader />

    console.log(TableMarketPlaceActiveTags, TableAliasActiveTags, TableVendorActiveTags);
    

    return <div className={style.container}>
        <div className={style.header__container}>
            <h2 className={style.title}>Таблица</h2>
            <div className={style.tools}>
                <button className={style.btn_default} title='Сбосить филтрацию' onClick={handleDefault}><Reset stroke={allFilters.length > 0 ? '#D321CC' : '#7e84a373'} /></button>
                <TableFilterSelect icon={<Market />} title='Фильтрация по магазину' name='marketplace_name' stateName='TableSelectMarketplace' isOpen={TableSelectMarketplaceIsOpen} options={TableMarketplaceTags} value={TableMarketPlaceActiveTags} setValue={(item) => dispatch(setTableMarketplaceTags(item))}/>
                <TableFilterSelect icon={<Cable />} title='Фильтрация по кабелю' name='alias_name' stateName='TableSelectAlias' isOpen={TableSelectAliasIsOpen} options={TableAliasTags} value={TableAliasActiveTags} setValue={(item) => dispatch(setTableAliasTags(item))}/>        
                <TableFilterSelect icon={<Vendor />} title='Фильтрация по производителю' name='vendor_name' stateName='TableSelectVendor' isOpen={TableSelectVendorIsOpen} options={TableVendorTags} value={TableVendorActiveTags } setValue={(item) => dispatch(setTableVendorsTags(item))}/>        
            </div>
        </div>
        <div className={style.table}>
            {filterMarkets.map((item, index) => {
                return <div className={style.table__column} key={index}>
                    <h3>{item.marketplace_name}</h3>
                    <div className={style.table__body}>
                        {item?.aliases?.map((elem, index) => {
                            return  elem?.prices?.map((item, index) => {
                                return <TableItem key={index} data={{...item, alias_id : elem.alias_id, alias_name : elem.alias_name}} />
                            })
                        })}
                    </div>
                </div>
            })}
        </div>
    </div>
}